import striptags from 'striptags';
import clip from 'text-clipper';

export function truncate(
    str,
    num,
    { forceEllipsis, noEllipsisIfEmpty } = {
        forceEllipsis: false,
        noEllipsisIfEmpty: false,
    },
) {
    const ellipsisPart = '...';

    if (str === undefined) {
        return noEllipsisIfEmpty ? '' : ellipsisPart;
    }

    if (str.length <= num) {
        return forceEllipsis ? `${str}${ellipsisPart}` : str;
    }
    return str.slice(0, num) + ellipsisPart;
}

export function truncateHTML(str, num) {
    try {
        return clip(str, num, { html: true });
    } catch (e) {
        console.log("FOUND STRIP TAG ERROR")
        return clip(striptags(str), num, { html: true });
    }
}
